import { Link } from "react-router-dom";

const friendLinks = [
  { label: "国产电影资料库", href: "#" },
  { label: "电视剧频道", href: "#" },
  { label: "影视行业观察", href: "#" },
  { label: "影迷社区", href: "#" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-background-200 bg-secondary-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                国产精品久久
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              专注国产电影、电视剧等优质影视资源与最新影视资讯的综合内容平台，帮助影迷轻松查找、了解并发现值得一看的国产佳作。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-foreground-500">
              本站所有影视资料均为演示内容，仅用于信息展示，不提供视频播放与下载服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-3">
              <li><Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">首页</Link></li>
              <li><Link to="/category/movie" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">电影</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">电视剧</Link></li>
              <li><Link to="/news" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">影视资讯</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">友情链接</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <h4 className="mt-6 text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="mt-4 flex flex-col gap-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-500" />
                contact@guochanjj.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base text-primary-500" />
                400-000-8888
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 国产精品久久 · 版权所有 · 演示站点
          </p>
          <p className="text-xs text-foreground-500">
            本站内容仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}